import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getSizeByRatio } from 'libs/common/utils';

var calculateCrop = function calculateCrop(_ref) {
  var image = _ref.image,
      originalCrop = _ref.originalCrop,
      imageRatio = _ref.imageRatio;

  if (originalCrop !== undefined) {
    if (image.naturalWidth !== 0 && image.naturalHeight !== 0) {
      var ratioX = image.naturalWidth / image.width;
      var ratioY = image.naturalHeight / image.height;
      return {
        width: Math.round(originalCrop.width / ratioX),
        height: Math.round(originalCrop.height / ratioY),
        x: Math.round(originalCrop.x / ratioX),
        y: Math.round(originalCrop.y / ratioY),
        unit: 'px',
        aspect: imageRatio
      };
    }

    return _objectSpread(_objectSpread({}, originalCrop), {}, {
      unit: 'px',
      aspect: imageRatio
    });
  }

  if (imageRatio !== undefined) {
    return _objectSpread(_objectSpread({
      aspect: imageRatio,
      unit: 'px'
    }, getSizeByRatio(image.width, image.height, imageRatio)), {}, {
      x: 0,
      y: 0
    });
  }

  return {
    unit: 'px',
    width: image.width,
    height: image.height,
    x: 0,
    y: 0
  };
};

export default calculateCrop;